import { Component, inject, Input, OnInit, output, signal, HostListener, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DropdownComponent, IconComponent, UserStateService, VersionService } from '@net3-multiplatform-client/libs';

@Component({
  selector: 'app-user-dropdown',
   styleUrls: ['./user-dropdown.component.scss'],
  templateUrl: './user-dropdown.component.html',
  imports:[CommonModule,RouterModule,DropdownComponent,IconComponent]
})
export class UserDropdownComponent implements OnInit {

  isOpen = false;
  
  readonly userState: UserStateService = inject(UserStateService);
  private versionService = inject(VersionService);
  private elementRef = inject(ElementRef);

  @Input() showButtonBack = true;

  user = this.userState.user;
  signOutClicked = output<void>();
  versionInfo = signal<any>(null);
  
  async ngOnInit() {
    const versionData = await this.versionService.getVersionInfo();
    this.versionInfo.set(versionData);
  }

  get firstName(): string {
  return this.user()?.name?.split(' ')[0] ?? '';
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  signOut(){
    this.signOutClicked.emit();
  }

// Escolta qualsevol interacció de punter (ratolí, touch) a tota la finestra.
// Això és necessari per detectar clicks o taps fora del component i tancar el dropdown.
@HostListener('window:pointerdown', ['$event'])
clickOutside(event: Event) {
  // `event.target` és l'element exacte sobre el qual l'usuari ha clicat o tocat.
  // `this.elementRef.nativeElement` és l'element arrel del component (el div que conté el dropdown).
  // `contains` retorna true si el click ha estat dins del component.  
  if (!this.elementRef.nativeElement.contains(event.target)) {
    // Si el click ha estat fora del component:tanquem el dropdown canviant l'estat `isOpen` a false.
    this.isOpen = false;
  }
  // Si el click ha estat dins del component, no fem res,
  // així el dropdown es manté obert.
}

}